export default __webpack_public_path__ + "static/media/img-0212-mexico-full-face.65585430.png";